
import { ButtonContent } from "../global/boton/ButtonContent";
import { GiRibbonMedal } from "react-icons/gi";
import { AiOutlineTeam } from "react-icons/ai";
import { FaHome } from "react-icons/fa";

function HeroSection({ bgImg, bgImg1, bgImg2, bgImg3, title, texts }) {

  const BgImages = [
    bgImg,
    bgImg1,
    bgImg2,
    bgImg3,
  ]
  return (
    <>
      <div className="pic-wrapper svgHerosection1  w-full h-screen" >
        {
          BgImages.map((item, index) => {
            return (
              <figure
                key={index}
                className={`pic-${index + 1}`}
                style={{ background: `url("${item}")` }}
              ></figure>
            )
          })
        }
        <div className="z-10 relative w-4/5 mx-auto h-full grid md:grid-cols-2 grid-cols-1 justify-center items-center md:pb-[180px] md:pt-[320px] pt-[300px] pb-[100px]">
          <div>
            <div className="w-full flex flex-col justify-center items-center">
              <h1 className="text-white text-center text-[35px] md:text-[60px]">
                {title}
              </h1>
              <p className="text-white text-center">
                {texts}
              </p>
            </div>
            <div className="w-full flex justify-center py-5">
              <ButtonContent btnStyle={'three'} />
            </div>
          </div>

          <div className="flex items-start">
            <img className="md:-mt-20 mt-0 w-[700px]" src="https://firebasestorage.googleapis.com/v0/b/imagenessanti-2a052.appspot.com/o/SELLO_Mesa%20de%20trabajo%201.png?alt=media&token=c0121025-7d79-420b-8290-7e13a6e360d5&_gl=1*h1un93*_ga*MTg3NzIxNTgxMi4xNjczOTA2Mjk5*_ga_CW55HF8NVT*MTY4NTc0NDM4MS4yMS4xLjE2ODU3NDQzODQuMC4wLjA" alt="garantia chap"/>
          </div>

        </div>
      </div>
      <div className=" md:w-[70%] w-[100%] bg-2 text-white md:-mt-32 -mb-12 -mt-20 relative md:py-14 py-2 homi">
        <ul className="flex md:flex-row flex-col justify-around ml-5 md:ml-0">
          <h5 className="flex items-center" data-aos="zoom-in">
            <FaHome
              fontSize={70}
              className="text-white mr-2"
            />
            BEST SERVICE</h5>
          <h5 className="flex items-center" data-aos="zoom-in" data-aos-duration="1000">
            <AiOutlineTeam
              fontSize={70}
              className="text-white"
            />
            PROFESSIONAL TEAM</h5>
          <h5 className="flex items-center" data-aos="zoom-in" data-aos-duration="1500">
            <GiRibbonMedal
              fontSize={70}
              className="text-white"
            />BEST QUALITY</h5>
        </ul>
      </div>
    </>
  );
}

export default HeroSection;
